import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const companyLinks = [
    { name: t('footer.aboutUs'), href: '/about' },
    { name: t('footer.contactUs'), href: 'https://community.h2chain.io' },
  ];

  const productLinks = [
    { name: t('footer.h2Swap'), href: 'https://h2swap.org' },
    { name: t('footer.h2Explorer'), href: 'http://h2scan.io' },
    { name: t('footer.h2Bridge'), href: 'https://h2bridge.net' },
     { name: t('footer.h2Stake'), href: 'https://stake.h2chain.io' },
  ];

  return (
    <footer className="bg-white dark:bg-[#111111] text-gray-600 dark:text-gray-400 border-t border-gray-200 dark:border-gray-800 transition-colors duration-300">
      <div className="w-full px-4 sm:px-6 lg:px-12 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo Section */}
          <div className="flex items-start">
            <div className="flex items-center gap-3">
              <img 
                src="/h2_logo.svg" 
                alt="H2Chain Logo" 
                className="w-8 h-8"
              />
              <span className="text-xl font-semibold text-gray-900 dark:text-white">
                H2 Chain
              </span>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-gray-900 dark:text-white font-semibold mb-4 text-sm sm:text-base">
              {t('footer.company')}
            </h3>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-600 dark:text-gray-400 hover:text-[#86E92A] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products & Services Links */}
          <div>
            <h3 className="text-gray-900 dark:text-white font-semibold mb-4 text-sm sm:text-base">
              {t('footer.productsServices')}
            </h3>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-600 dark:text-gray-400 hover:text-[#86E92A] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-800 text-center">
          <p className="text-gray-500 dark:text-gray-500 text-xs sm:text-sm">
            © {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
